export const PartnerImagePath = (partnerKey: string, imagePath: string) =>
  new Promise<string>((resolve) => {
    const pathPartner = `/media/partners/${partnerKey}/${imagePath}`;
    const pathDefault = `/media/partners/default/${imagePath}`;
    const img = new Image();
    img.onload = () => resolve(pathPartner);
    img.onerror = () => resolve(pathDefault);
    img.src = pathPartner;
  });
